import React, { ReactElement } from 'react';

interface IProps {
  className?: string,
  fill?: string,
  viewBox?: string,
  width?: string,
  height?: string,
  tabIndex?: number,
  title?: string,
  desc?: string,
  titleId?: string,
  descId?: string
}
interface IIconProps extends IProps {
  children: ReactElement
}

const Icon = (props: IIconProps): JSX.Element => {
  // these describe the <title>/<desc> children — they must not reach the DOM node
  const svgProps = { ...props };
  delete svgProps.title;
  delete svgProps.desc;
  delete svgProps.titleId;
  delete svgProps.descId;

  return (
    <svg {...svgProps}>{props.children}</svg>
  );
};

Icon.defaultProps = {
  width: '18px',
  height: '18px',
  viewBox: '0 0 32 32',
};

const RightArrow = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <>
      <title id={props.titleId || 'play-button'}>{props.title || 'Play button'}</title>
      <desc id={props.descId || 'desc-for-play-button'}>{props.desc || 'Button that reproduces a video.'}</desc>
      <path d='M6 4l20 12-20 12z' />
    </>
  </Icon>;


const ArrowLeft = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <>
      <title id='play-button'>{props.title || 'Action button'}</title>
      <desc id='desc-for-play-button'>{props.desc || 'Button that move slide'}</desc>
      <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"/>
    </>
  </Icon>;

const ArrowRight = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <>
      <title id='play-button'>Action button</title>
      <desc id='desc-for-play-button'>Button that move slide</desc>
      <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/>
    </>
  </Icon>;

const Add = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <path d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 11 L 7 11 L 7 13 L 11 13 L 11 17 L 13 17 L 13 13 L 17 13 L 17 11 L 13 11 L 13 7 L 11 7 z" />
  </Icon>;

const Added = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <path d="M 12 2 C 6.5 2 2 6.5 2 12 C 2 17.5 6.5 22 12 22 C 17.5 22 22 17.5 22 12 C 22 10.9 21.8 9.8007812 21.5 8.8007812 L 19.800781 10.400391 C 19.900781 10.900391 20 11.4 20 12 C 20 16.4 16.4 20 12 20 C 7.6 20 4 16.4 4 12 C 4 7.6 7.6 4 12 4 C 13.6 4 15.100391 4.5007812 16.400391 5.3007812 L 17.800781 3.9003906 C 16.200781 2.7003906 14.2 2 12 2 z M 21.300781 3.3007812 L 11 13.599609 L 7.6992188 10.300781 L 6.3007812 11.699219 L 11 16.400391 L 22.699219 4.6992188 L 21.300781 3.3007812 z" />
  </Icon>;

const Remove = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </Icon>;

const EmailAddress = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <path d="M 25 3 C 24.088 3 22.337438 3.1897813 20.898438 4.4257812 C 20.892339 4.4303829 20.852211 4.4657189 20.845703 4.4707031 C 20.395926 4.8125543 19.401587 5.6870478 17.986328 6.9140625 L 17.886719 7 L 11 7 C 10.447 7 10 7.447 10 8 L 10 13.962891 C 6.561 17.002891 3.6413281 19.603516 3.3613281 19.853516 L 12 26.583984 L 12 9 L 17.988281 9 A 1.0001 1.0001 0 0 0 18.462891 9 L 31.513672 9 A 1.0001 1.0001 0 0 0 31.859375 9 L 38 9 L 38 26.583984 L 46.638672 19.853516 C 46.357672 19.603516 43.439 17.002891 40 13.962891 L 40 8 C 40 7.447 39.553 7 39 7 L 32.056641 7 C 31.889251 6.8497223 31.735461 6.7174156 31.566406 6.5664062 C 30.429946 5.5480509 29.550023 4.7702444 29.150391 4.4667969 C 29.147127 4.4639983 29.143891 4.4617725 29.140625 4.4589844 C 29.107784 4.43096 29.074078 4.4097946 29.041016 4.3828125 C 28.887361 4.257439 28.731649 4.1372055 28.574219 4.0332031 C 28.384468 3.9075287 28.193105 3.7968349 28.001953 3.6992188 C 28.001953 3.6992188 28 3.6972656 28 3.6972656 C 28 3.6972656 27.998047 3.6972656 27.998047 3.6972656 C 27.61294 3.5016788 27.229847 3.356974 26.863281 3.2539062 C 26.493442 3.1497511 26.142519 3.0864962 25.824219 3.0488281 C 25.508563 3.0110781 25.228 3 25 3 z M 16 14 A 1.0001 1.0001 0 1 0 16 16 L 34 16 A 1.0001 1.0001 0 1 0 34 14 L 16 14 z M 16 19 A 1.0001 1.0001 0 1 0 16 21 L 27 21 A 1.0001 1.0001 0 1 0 27 19 L 16 19 z M 3 22.134766 L 3 41.136719 C 3.08 41.075719 3.153375 41.016125 3.234375 40.953125 C 6.708375 38.251125 11.477266 34.542297 15.197266 31.654297 L 3 22.134766 z M 47 22.134766 L 34.740234 31.703125 C 38.388234 34.582125 43.15 38.336187 47 41.367188 L 47 22.134766 z M 25 27.822266 C 24.749 27.822266 23.432797 27.872516 22.091797 28.853516 C 21.172797 29.532516 10.302891 37.990203 4.4628906 42.533203 C 3.9108906 42.962203 3.43 43.337922 3 43.669922 L 3 46 C 3 46.553 3.447 47 4 47 L 46 47 C 46.553 47 47 46.553 47 46 L 47 43.912109 C 39.971 38.380109 28.657 29.456125 27.875 28.828125 C 26.781 27.954125 25.604 27.822266 25 27.822266 z" />
  </Icon>;

const OutlookCalendar = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <><path fill="#1976d2" d="M28,13h14.533C43.343,13,44,13.657,44,14.467v19.066C44,34.343,43.343,35,42.533,35H28V13z" /><rect width="14" height="15.542" x="28" y="17.958" fill="#fff" /><polygon fill="#1976d2" points="27,44 4,39.5 4,8.5 27,4" /><path fill="#fff" d="M15.25,16.5c-3.176,0-5.75,3.358-5.75,7.5s2.574,7.5,5.75,7.5S21,28.142,21,24	S18.426,16.5,15.25,16.5z M15,28.5c-1.657,0-3-2.015-3-4.5s1.343-4.5,3-4.5s3,2.015,3,4.5S16.657,28.5,15,28.5z" /><rect width="2.7" height="2.9" x="28.047" y="29.737" fill="#1976d2" /><rect width="2.7" height="2.9" x="31.448" y="29.737" fill="#1976d2" /><rect width="2.7" height="2.9" x="34.849" y="29.737" fill="#1976d2" /><rect width="2.7" height="2.9" x="28.047" y="26.159" fill="#1976d2" /><rect width="2.7" height="2.9" x="31.448" y="26.159" fill="#1976d2" /><rect width="2.7" height="2.9" x="34.849" y="26.159" fill="#1976d2" /><rect width="2.7" height="2.9" x="38.25" y="26.159" fill="#1976d2" /><rect width="2.7" height="2.9" x="28.047" y="22.706" fill="#1976d2" /><rect width="2.7" height="2.9" x="31.448" y="22.706" fill="#1976d2" /><rect width="2.7" height="2.9" x="34.849" y="22.706" fill="#1976d2" /><rect width="2.7" height="2.9" x="38.25" y="22.706" fill="#1976d2" /><rect width="2.7" height="2.9" x="31.448" y="19.112" fill="#1976d2" /><rect width="2.7" height="2.9" x="34.849" y="19.112" fill="#1976d2" /><rect width="2.7" height="2.9" x="38.25" y="19.112" fill="#1976d2" /></>
  </Icon>;

const GoogleCalendar = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <><rect width="22" height="22" x="13" y="13" fill="#fff" /><polygon fill="#1e88e5" points="25.68,20.92 26.688,22.36 28.272,21.208 28.272,29.56 30,29.56 30,18.616 28.56,18.616" /><path fill="#1e88e5" d="M22.943,23.745c0.625-0.574,1.013-1.37,1.013-2.249c0-1.747-1.533-3.168-3.417-3.168 c-1.602,0-2.972,1.009-3.33,2.453l1.657,0.421c0.165-0.664,0.868-1.146,1.673-1.146c0.942,0,1.709,0.646,1.709,1.44 c0,0.794-0.767,1.44-1.709,1.44h-0.997v1.728h0.997c1.081,0,1.993,0.751,1.993,1.64c0,0.904-0.866,1.64-1.931,1.64 c-0.962,0-1.784-0.61-1.914-1.418L17,26.802c0.262,1.636,1.81,2.87,3.6,2.87c2.007,0,3.64-1.511,3.64-3.368 C24.24,25.281,23.736,24.363,22.943,23.745z" /><polygon fill="#fbc02d" points="34,42 14,42 13,38 14,34 34,34 35,38" /><polygon fill="#4caf50" points="38,35 42,34 42,14 38,13 34,14 34,34" /><path fill="#1e88e5" d="M34,14l1-4l-1-4H9C7.343,6,6,7.343,6,9v25l4,1l4-1V14H34z" /><polygon fill="#e53935" points="34,34 34,42 42,34" /><path fill="#1565c0" d="M39,6h-5v8h8V9C42,7.343,40.657,6,39,6z" /><path fill="#1565c0" d="M9,42h5v-8H6v5C6,40.657,7.343,42,9,42z" /></>
  </Icon>;

const AddToCalendar = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <><path d="M 12 0 C 10.90625 0 10 0.90625 10 2 L 10 4 L 4 4 C 2.839844 4 2 4.839844 2 6 L 2 13 L 48 13 L 48 6 C 48 4.839844 47.160156 4 46 4 L 40 4 L 40 2 C 40 0.90625 39.09375 0 38 0 L 36 0 C 34.90625 0 34 0.90625 34 2 L 34 4 L 16 4 L 16 2 C 16 0.90625 15.09375 0 14 0 Z M 12 2 L 14 2 L 14 8 L 12 8 Z M 36 2 L 38 2 L 38 8 L 36 8 Z M 2 15 L 2 46 C 2 47.105469 2.894531 48 4 48 L 34.027344 48 C 35.695313 49.25 37.757813 50 40 50 C 45.515625 50 50 45.515625 50 40 C 50 37.757813 49.25 35.695313 48 34.027344 L 48 15 Z M 12 21 L 17 21 L 17 26 L 12 26 Z M 19 21 L 24 21 L 24 26 L 19 26 Z M 26 21 L 31 21 L 31 26 L 26 26 Z M 33 21 L 38 21 L 38 26 L 33 26 Z M 12 28 L 17 28 L 17 33 L 12 33 Z M 19 28 L 24 28 L 24 33 L 19 33 Z M 26 28 L 31 28 L 31 33 L 26 33 Z M 33 28 L 38 28 L 38 30.203125 C 36.074219 30.59375 34.351563 31.542969 33 32.871094 Z M 40 32 C 44.410156 32 48 35.589844 48 40 C 48 44.410156 44.410156 48 40 48 C 35.589844 48 32 44.410156 32 40 C 32 35.589844 35.589844 32 40 32 Z M 40 34.097656 C 39.398438 34.097656 39 34.5 39 35.097656 L 39 39 L 35.097656 39 C 34.5 39 34.097656 39.398438 34.097656 40 C 34.097656 40.601563 34.5 41 35.097656 41 L 39 41 L 39 44.902344 C 39 45.5 39.398438 45.902344 40 45.902344 C 40.601563 45.902344 41 45.5 41 44.902344 L 41 41 L 44.902344 41 C 45.5 41 45.902344 40.601563 45.902344 40 C 45.902344 39.398438 45.5 39 44.902344 39 L 41 39 L 41 35.097656 C 41 34.5 40.601563 34.097656 40 34.097656 Z M 12 35 L 17 35 L 17 40 L 12 40 Z M 19 35 L 24 35 L 24 40 L 19 40 Z M 26 35 L 31 35 L 31 35.671875 C 30.367188 36.980469 30 38.449219 30 40 L 26 40 Z" /></>
  </Icon>;

const RemoveFromCalendar = (props: IProps): JSX.Element => (
  <Icon {...props}>
    <g transform="translate(0.000000,72.000000) scale(0.100000,-0.100000)" fill='#cc0000' stroke="none">
      <path d="M120 675 c-4 -9 -19 -15 -35 -15 -26 0 -29 -3 -29 -35 l0 -35 186 0 185 0 -3 33 c-3 28 -7 32 -35 35 -21 2 -33 9 -33 18 0 8 -9 14 -20 14 -11 0 -20 -7 -20 -15 0 -12 -15 -15 -75 -15 -60 0 -75 3 -75 15 0 8 -9 15 -20 15 -11 0 -23 -7 -26 -15z m36 -30 c0 -14 -4 -25 -10 -25 -5 0 -10 11 -10 25 0 14 5 25 10 25 6 0 10 -11 10 -25z m190 0 c0 -14 -4 -25 -10 -25 -5 0 -10 11 -10 25 0 14 5 20 10 25 6 0 10 -11 10"/>
      <path d="M60 440 l0 -130 129 0 c76 0 132 -4 136 -10 3 -5 21 -10 39 -10 39 0 79 37 77 72 -1 13 -4 65 -7 116 l-6 92 -184 0 -184 0 0 -130z m110 60 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m60 0 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m50 0 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m60 0 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m-170 -50 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m58 -3 c2 -12 -3 -17 -17 -17 -15 0 -21 6 -21 21 0 25 33 22 38 -4z m52 3 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m60 10 c0 -5 -9 -14 -20 -20 -17 -9 -20 -8 -20 10 0 13 7 20 20 20 11 0 20 -4 20 -10z m64 -52 c21 -30 20 -54 -4 -78 -24 -24 -67 -26 -92 -3 -40 36 -9 103 47 103 24 0 39 -7 49 -22z m-234 -18 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m60 0 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m50 0 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z"/>
      <path d="M310 370 c0 -5 20 -10 45 -10 25 0 45 5 45 10 0 6 -20 10 -45 10 -25 0 -45 -4 -45 -10z"/>
    </g>
  </Icon>
);

const CheckedCalendar = (props: IProps): JSX.Element => (
  <Icon {...props}>
    <g transform="translate(0.000000,62.000000) scale(0.100000,-0.100000)" fill="#707070" stroke="none">
      <path d="M200 575 c-4 -9 -19 -15 -35 -15 -26 0 -29 -3 -29 -35 l0 -35 186 0 185 0 -3 33 c-3 28 -7 32 -35 35 -21 2 -33 9 -33 18 0 8 -9 14 -20 14 -11 0 -20 -7 -20 -15 0 -12 -15 -15 -75 -15 -60 0 -75 3 -75 15 0 8 -9 15 -20 15 -11 0 -23 -7 -26 -15z m36 -30 c0 -14 -4 -25 -10 -25 -5 0 -10 11 -10 25 0 14 5 25 10 25 6 0 10 -11 10 -25z m190 0 c0 -14 -4 -25 -10 -25 -5 0 -10 11 -10 25 0 14 5 25 10 25 6 0 10 -11 10"/>
      <path d="M140 340 l0 -130 129 0 c76 0 132 -4 136 -10 3 -5 21 -10 39 -10 39 0 79 37 77 72 -1 13 -4 65 -7 116 l-6 92 -184 0 -184 0 0 -130z m110 60 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m60 0 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m50 0 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m60 0 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m-170 -50 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m58 -3 c2 -12 -3 -17 -17 -17 -15 0 -21 6 -21 21 0 25 33 22 38 -4z m52 3 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m60 10 c0 -5 -9 -14 -20 -20 -17 -9 -20 -8 -20 10 0 13 7 20 20 20 11 0 20 -4 20 -10z m64 -52 c21 -30 20 -54 -4 -78 -24 -24 -67 -26 -92 -3 -40 36 -9 103 47 103 24 0 39 -7 49 -22z m-234 -18 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m60 0 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z m50 0 c0 -13 -7 -20 -20 -20 -13 0 -20 7 -20 20 0 13 7 20 20 20 13 0 20 -7 20 -20z"/>
      <path d="M382 320 c-7 -13 -22 -35 -22 -48 0 -33 39 -69 73 -69 61 0 89 76 44 118 -30 28 -68 28 -95 -1z m88 -25 c0 -5 -11 -19 -25 -32 -20 -19 -27 -21 -40 -10 -21 18 -19 33 3 21 14 -7 21 -5 30 10 12 19 32 26 32 10z"/>
    </g>
  </Icon>
);

const Warning = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <g stroke="none" fill="none" fillRule="evenodd" >
      <g fill="#cc0000">
        <path d="M15.4242327,5.14839275 C16.2942987,3.74072976 17.707028,3.74408442 18.5750205,5.14839275 L29.3601099,22.59738 C30.5216388,24.4765951 29.6755462,26 27.4714068,26 L6.5278464,26 C4.32321557,26 3.47386317,24.4826642 4.63914331,22.59738 L15.4242327,5.14839275 L15.4242327,5.14839275 Z M16.353181,5.5229211 C16.7005152,4.96165163 17.2647678,4.9634187 17.6110318,5.52292108 L28.6162937,23.3055078 C29.1954663,24.2413498 28.7622271,24.9999996 27.6746349,24.9999996 L6.29039231,25 C5.19115596,25 4.76644971,24.2463265 5.34866262,23.3055082 L16.353181,5.5229211 L16.353181,5.5229211 Z M17,11 C16.4477153,11 16,11.4530363 16,11.9970301 L16,18.0029699 C16,18.5536144 16.4438648,19 17,19 C17.5522847,19 18,18.5469637 18,18.0029699 L18,11.9970301 C18,11.4463856 17.5561352,11 17,11 L17,11 Z M17,23 C17.5522848,23 18,22.5522848 18,22 C18,21.4477152 17.5522848,21 17,21 C16.4477152,21 16,21.4477152 16,22 C16,22.5522848 16.4477152,23 17,23 L17,23 Z" ></path>
      </g>
    </g>
  </Icon>;

const ExpandArrow = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.998"
      height="6"
      viewBox="0 0 10.998 6"
    >
      <path
        fill="#1276db"
        d="M.51 0a.5.5 0 01.349.154l4.64 4.64 4.64-4.64a.5.5 0 11.706.706L5.853 5.854a.5.5 0 01-.706 0L.154.861a.5.5 0 01.357-.86z"
      ></path>
    </svg>
  </Icon>;

const Eye = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 512 512"
    >
      <path d="M320 256a64 64 0 11-64-64 64.07 64.07 0 0164 64zm189.81 9.42C460.86 364.89 363.6 426.67 256 426.67S51.14 364.89 2.19 265.42a21.33 21.33 0 010-18.83C51.14 147.11 148.4 85.33 256 85.33s204.86 61.78 253.81 161.25a21.33 21.33 0 010 18.84zM362.67 256A106.67 106.67 0 10256 362.67 106.79 106.79 0 00362.67 256z"></path>
    </svg>
  </Icon>;

const CrossedEye = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 512 512"
    >
      <path d="M409.84 132.33l95.91-95.91a21.33 21.33 0 10-30.17-30.17L6.25 475.58a21.33 21.33 0 1030.17 30.17L140.77 401.4A275.84 275.84 0 00256 426.67c107.6 0 204.85-61.78 253.81-161.25a21.33 21.33 0 000-18.83 291 291 0 00-99.97-114.26zM256 362.67a105.78 105.78 0 01-58.7-17.8l31.21-31.21A63.29 63.29 0 00256 320a64.07 64.07 0 0064-64 63.28 63.28 0 00-6.34-27.49l31.21-31.21A106.45 106.45 0 01256 362.67zM2.19 265.42a21.33 21.33 0 010-18.83C51.15 147.11 148.4 85.33 256 85.33a277 277 0 0170.4 9.22l-55.88 55.88a105.9 105.9 0 00-120.08 120.09l-82.56 82.56a295.2 295.2 0 01-65.69-87.66z"></path>
    </svg>
  </Icon>;


const ExpandIcon = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <>
      <title>Expand table view</title>
      <desc id='desc-for-play-button'>Expended table view</desc>
      <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
        <g className="currentLayer">
          <rect height="8" width="8" y="0" x="0" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="8" width="8" y="0" x="10" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="8" width="8" y="10" x="0" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="8" width="8" y="10" x="10" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
        </g>
      </svg>
    </>
  </Icon>;

const CollapseIcon = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <>
      <title>Collapse table view</title>
      <desc id='desc-for-play-button'>Collapsed table view</desc>
      <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
        <g className="currentLayer">
          <rect height="3.75" width="3.75" y="0" x="0" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="0" x="4.75" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="0" x="9.5" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="0" x="14.25" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>

          <rect height="3.75" width="3.75" y="4.75" x="0" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="4.75" x="4.75" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="4.75" x="9.5" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="4.75" x="14.25" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>

          <rect height="3.75" width="3.75" y="9.5" x="0" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="9.5" x="4.75" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="9.5" x="9.5" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="9.5" x="14.25" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>

          <rect height="3.75" width="3.75" y="14.25" x="0" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="14.25" x="4.75" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="14.25" x="9.5" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
          <rect height="3.75" width="3.75" y="14.25" x="14.25" fillOpacity="null" strokeOpacity="null" strokeWidth="null" stroke="null"/>
        </g>
      </svg>
    </>
  </Icon>;

const CheckmarkIcon = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <svg fill='inherit' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50'>
      <path d='M 41.9375 8.625 C 41.273438 8.648438 40.664063 9 40.3125 9.5625 L 21.5 38.34375 L 9.3125 27.8125 C 8.789063 27.269531 8.003906 27.066406 7.28125 27.292969 C 6.5625 27.515625 6.027344 28.125 5.902344 28.867188 C 5.777344 29.613281 6.078125 30.363281 6.6875 30.8125 L 20.625 42.875 C 21.0625 43.246094 21.640625 43.410156 22.207031 43.328125 C 22.777344 43.242188 23.28125 42.917969 23.59375 42.4375 L 43.6875 11.75 C 44.117188 11.121094 44.152344 10.308594 43.78125 9.644531 C 43.410156 8.984375 42.695313 8.589844 41.9375 8.625 Z'/>
    </svg>
  </Icon>;

const CheckmarkCircleIcon = (props: IProps): JSX.Element =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '23'}
    height={props.height || '22'}
    viewBox="0 0 23 22"
    fill="none"
    className={props.className}
  >
    <path
      d="M11.1073 0C4.98275 0 0 4.9346 0 11C0 17.0654 4.98275 22 11.1073 22C17.2319 22 22.2147 17.0654 22.2147 11C22.2147 9.7614 21.997 8.57362 21.6138 7.46152L19.8153 9.24258C19.9319 9.81018 19.9932 10.3983 19.9932 11C19.9932 15.8521 16.0068 19.8 11.1073 19.8C6.20789 19.8 2.22147 15.8521 2.22147 11C2.22147 6.1479 6.20789 2.2 11.1073 2.2C12.9212 2.2 14.6083 2.74328 16.0167 3.67168L17.6069 2.09688C15.7764 0.783475 13.5343 0 11.1073 0ZM21.4294 1.42227L9.9966 12.7445L6.33899 9.12226L4.76834 10.6777L9.9966 15.8555L23 2.97773L21.4294 1.42227Z"
      fill={props.fill || '#00787A'}
    />
  </svg>;

const WarningTriangleIcon = (props: IProps): JSX.Element =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '26'}
    height={props.height || '23'}
    viewBox="0 0 26 23"
    fill="none"
    className={props.className}
  >
    <path
      d="M11.2679 1.5C12.0377 0.166667 13.9623 0.166667 14.7321 1.5L25.1244 19.5C25.8942 20.8333 24.9319 22.5 23.3923 22.5H2.60769C1.06809 22.5 0.105839 20.8333 0.875639 19.5L11.2679 1.5Z"
      fill={props.fill || '#D87F03'}
    />
    <path
      d="M13 8V14"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="13" cy="18" r="1" fill="white" />
  </svg>;

const EyeIcon = (props: IProps): JSX.Element =>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width={props.width || '16'} 
    height={props.height || '11'} 
    viewBox="0 0 16 11" 
    fill="none"
    className={props.className}
  >
    <path 
      d="M8 0C3.24358 0 0.171194 4.91263 0.115625 5.00208C0.0408285 5.0963 8.08654e-05 5.21304 0 5.33333C9.4615e-05 5.43653 0.030128 5.53749 0.0864583 5.62396C0.0871491 5.625 0.0878436 5.62604 0.0885417 5.62708C0.0977116 5.64601 2.67671 10.6667 8 10.6667C13.3007 10.6667 15.8759 5.69533 15.9073 5.63438C15.9094 5.63093 15.9115 5.62745 15.9135 5.62396C15.9699 5.53749 15.9999 5.43653 16 5.33333C16 5.21352 15.9596 5.0972 15.8854 5.00313C15.8851 5.00278 15.8847 5.00243 15.8844 5.00208C15.8288 4.91263 12.7564 0 8 0ZM8 1.6C10.0619 1.6 11.7333 3.27147 11.7333 5.33333C11.7333 7.3952 10.0619 9.06667 8 9.06667C5.93813 9.06667 4.26667 7.3952 4.26667 5.33333C4.26667 3.27147 5.93813 1.6 8 1.6ZM8 3.73333C7.57565 3.73333 7.16869 3.9019 6.86863 4.20196C6.56857 4.50202 6.4 4.90899 6.4 5.33333C6.4 5.75768 6.56857 6.16465 6.86863 6.4647C7.16869 6.76476 7.57565 6.93333 8 6.93333C8.42435 6.93333 8.83131 6.76476 9.13137 6.4647C9.43143 6.16465 9.6 5.75768 9.6 5.33333C9.6 4.90899 9.43143 4.50202 9.13137 4.20196C8.83131 3.9019 8.42435 3.73333 8 3.73333Z" 
      fill={props.fill || '#00787A'}
    />
  </svg>;

const LinkIcon = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <svg
      version="1.0" xmlns='http://www.w3.org/2000/svg'
      width="24.000000pt" height="24.000000pt"
      viewBox="0 0 24.000000 24.000000"
    >

      <g
        transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
        // fill="#000000"
        stroke="none"
      >
        <path
          d="M26 154 c-21 -21 -20 -47 2 -67 20 -18 72 -23 72 -7 0 6 -10 10 -22
10 -58 1 -67 53 -10 58 17 2 32 7 32 13 0 15 -57 10 -74 -7z"
        />
        <path
          d="M140 160 c0 -5 10 -10 23 -10 57 -1 66 -53 9 -58 -40 -4 -43 -22 -3
-22 54 0 80 50 43 83 -20 18 -72 23 -72 7z"
        />
        <path
          d="M70 120 c0 -5 23 -10 50 -10 28 0 50 5 50 10 0 6 -22 10 -50 10 -27
0 -50 -4 -50 -10z"
        />
      </g>
    </svg>
  </Icon>;


const PhoneIcon = (props: IProps): JSX.Element =>
  <Icon {...props}>
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px" y="0px"
      viewBox="0 0 122.88 122.27"
    >
      <g><path d="M33.84,50.25c4.13,7.45,8.89,14.6,15.07,21.12c6.2,6.56,13.91,12.53,23.89,17.63c0.74,0.36,1.44,0.36,2.07,0.11 c0.95-0.36,1.92-1.15,2.87-2.1c0.74-0.74,1.66-1.92,2.62-3.21c3.84-5.05,8.59-11.32,15.3-8.18c0.15,0.07,0.26,0.15,0.41,0.21 l22.38,12.87c0.07,0.04,0.15,0.11,0.21,0.15c2.95,2.03,4.17,5.16,4.2,8.71c0,3.61-1.33,7.67-3.28,11.1 c-2.58,4.53-6.38,7.53-10.76,9.51c-4.17,1.92-8.81,2.95-13.27,3.61c-7,1.03-13.56,0.37-20.27-1.69 c-6.56-2.03-13.17-5.38-20.39-9.84l-0.53-0.34c-3.31-2.07-6.89-4.28-10.4-6.89C31.12,93.32,18.03,79.31,9.5,63.89 C2.35,50.95-1.55,36.98,0.58,23.67c1.18-7.3,4.31-13.94,9.77-18.32c4.76-3.84,11.17-5.94,19.47-5.2c0.95,0.07,1.8,0.62,2.25,1.44 l14.35,24.26c2.1,2.72,2.36,5.42,1.21,8.12c-0.95,2.21-2.87,4.25-5.49,6.15c-0.77,0.66-1.69,1.33-2.66,2.03 c-3.21,2.33-6.86,5.02-5.61,8.18L33.84,50.25L33.84,50.25L33.84,50.25z"/></g>
    </svg>
  </Icon>;


export default {
  RightArrow,
  ArrowRight,
  ArrowLeft,
  Add,
  Added,
  Remove,
  EmailAddress,
  OutlookCalendar,
  GoogleCalendar,
  AddToCalendar,
  Warning,
  WarningTriangleIcon,
  ExpandArrow,
  Eye,
  EyeIcon,
  CrossedEye,
  ExpandIcon,
  CollapseIcon,
  CheckmarkIcon,
  CheckmarkCircleIcon,
  LinkIcon,
  PhoneIcon,
  RemoveFromCalendar,
  CheckedCalendar
};
